module.exports = __webpack_public_path__ + "img/up.85fb682a.png";